import React, { Component } from "react";
import styled, { keyframes } from "styled-components";
import { NavLink } from "react-router-dom";
import "../../style/hamburgers.css";
import logo from "../../assets/img/logo.svg";
import facebook from "../../assets/img/facebook-white.png";
import twitter from "../../assets/img/twitter-white.png";
import instagram from "../../assets/img/instagram-white.png";

class MobileMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileMenuOpen: false
    };
  }

  toggleMobileMenuVisibility() {
    this.setState({
      mobileMenuOpen: !this.state.mobileMenuOpen
    });
  }

  closeMobileMenu() {
    this.setState({
      mobileMenuOpen: false
    });
  }

  render() {
    return (
      <Container>
        <MobileMenuIcon>
          <button
            className={
              this.state.mobileMenuOpen
                ? "hamburger hamburger--spin is-active"
                : "hamburger hamburger--spin"
            }
            type="button"
            aria-label="Menu"
            aria-controls="navigation"
            onClick={this.toggleMobileMenuVisibility.bind(this)}
          >
            <span className="hamburger-box">
              <span className="hamburger-inner" />
            </span>
          </button>
        </MobileMenuIcon>
        <Main
          style={
            this.state.mobileMenuOpen
              ? { display: "flex" }
              : { display: "none" }
          }
        >
          <MenuLogoContainer>
            <MenuLink
              exact
              to="/"
              activeStyle={activeStyle}
              onClick={() => this.toggleMobileMenuVisibility()}
            >
              <Logo src={logo} />
            </MenuLink>
          </MenuLogoContainer>

          <Nav out={this.state.mobileMenuOpen}>
            <MenuItem>
              <MenuLink
                exact
                to="/services"
                activeStyle={activeStyle}
                onClick={() => this.toggleMobileMenuVisibility()}
              >
                Services
              </MenuLink>
            </MenuItem>
            <MenuItem>
              <MenuLink
                exact
                to="/gallery"
                activeStyle={activeStyle}
                onClick={() => this.toggleMobileMenuVisibility()}
              >
                Gallery
              </MenuLink>
            </MenuItem>
            <MenuItem>
              <MenuLink
                exact
                to="/feedback"
                activeStyle={activeStyle}
                onClick={() => this.toggleMobileMenuVisibility()}
              >
                Feedback
              </MenuLink>
            </MenuItem>
            <MenuItem>
              <MenuLink
                exact
                to="/contact"
                activeStyle={activeStyle}
                onClick={() => this.toggleMobileMenuVisibility()}
              >
                Contact
              </MenuLink>
            </MenuItem>
          </Nav>
          <MenuFooterContainer>
            <SocialIcon src={facebook} />
            <SocialIcon src={twitter} />
            <SocialIcon src={instagram} />
          </MenuFooterContainer>
        </Main>
      </Container>
    );
  }
}

const activeStyle = {
  textDecoration: "underline"
};

const Container = styled.div`
  @media only screen and (min-width: 980px) {
    display: none;
  }
`;

const Main = styled.div`
  list-style: none;
  margin: 0;
  padding: 0;
  font-weight: 200;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.95);
  display: flex;
  position: fixed;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0px;
  bottom: 0px;
  right: 0px;
  left: 0px;
  z-index: 1;
  @media only screen and (min-width: 980px) {
    display: none;
  }
  animation: ${props => (props.out ? fadeIn : fadeIn)} 0.08s linear 1;
  @media only screen and (min-width: 980px) {
    display: none;
  }
`;

const MobileMenuIcon = styled.div`
  color: #ffffff;
  position: fixed;
  top: 0px;
  right: 0px;
  height: 65px;
  padding: 16px 5px;
  z-index: 1000;
  overflow: hidden;
`;

const MenuLogoContainer = styled.div`
  overflow: hidden;
  padding: 0;
  display: inline;
  width: 100%;
  flex: 0 0 auto;
  background: #000000;
`;

const Logo = styled.img`
  width: 150px;
  margin: 70px auto 20px auto;
  display: block;
`;

const MenuFooterContainer = styled.div`
  overflow: hidden;
  margin: 0;
  display: inline;
  width: 100%;
  flex: 0 0 auto;
  background: #000000;
  padding: 20px 0 0 0;
`;

const SocialIcon = styled.img`
  padding: 0 10px 40px 10px;
  height: 40px;
`;

const Nav = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  font-weight: 200;
  width: 100%;
  background: rgba(0, 0, 0, 0.95);
  display: flex;
  flex: 1;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  z-index: 1;
  @media only screen and (min-width: 980px) {
    display: none;
  }
  animation: ${props => (props.out ? fadeIn : fadeIn)} 0.08s linear 1;
`;

const MenuItem = styled.li`
  display: flex;
  width: 100%;
  padding: 10px 0;
  flex: 1 1 auto;
  align-items: center;
  justify-contents: center;
`;

const MenuLink = styled(NavLink)`
  text-decoration: none;
  color: #ffffff;
  font-family: "Pathway Gothic One";
  width: 100%;
  flex: 1;
  display: block;
  font-size: 25px;
  text-transform: uppercase;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    top: 100%;
  }

  to {
    opacity: 0.95;
    top: 0%;
  }
`;

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/components/navigation/MobileMenu.js